export function debounce(func, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
}
export function throttle(func, limit, options = {
    leading: true,
    trailing: false,
}) {
    let timeout = null;
    let lastArgs = null;
    let lastContext = null;
    let lastCallTime = null;
    const invokeFunction = () => {
        if (lastArgs !== null && lastContext !== null) {
            func.apply(lastContext, lastArgs);
            lastCallTime = Date.now();
            lastArgs = null;
            lastContext = null;
            timeout = null;
        }
    };
    return function (...args) {
        const now = Date.now();
        const shouldInvoke = options.leading && lastCallTime === null;
        lastArgs = args;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastContext = this;
        if (lastCallTime !== null && now - lastCallTime >= limit) {
            invokeFunction();
        }
        if (timeout === null) {
            timeout = setTimeout(() => {
                if (options.trailing && lastArgs !== null) {
                    invokeFunction();
                }
            }, shouldInvoke ? limit - (now - (lastCallTime !== null && lastCallTime !== void 0 ? lastCallTime : now)) : limit);
        }
        if (shouldInvoke) {
            invokeFunction();
        }
    };
}
//# sourceMappingURL=utilities.js.map